import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const ExpandReverse = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M39.7949 37.8097C40.5824 39.1036 39.1014 40.5842 37.8076 39.795L24.8096 26.796V36.048C24.8093 36.8234 24.1808 37.452 23.4053 37.4523C22.6296 37.4523 22.0003 36.8236 22 36.048V23.4054C22 22.6295 22.6294 22.0001 23.4053 22.0001H36.0479C36.8236 22.0002 37.4521 22.6296 37.4521 23.4054C37.4517 24.1808 36.8234 24.8096 36.0479 24.8097H26.7959L40.0254 38.0392L39.7949 37.8097Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				d='M2.23047 4.20629C1.44302 2.91241 2.92403 1.43181 4.21777 2.22094L17.2158 15.22V5.96801C17.2161 5.19252 17.8446 4.56392 18.6201 4.56371C19.3958 4.56371 20.0251 5.19239 20.0254 5.96801V18.6106C20.0254 19.3864 19.3959 20.0159 18.6201 20.0159H5.97754C5.20176 20.0158 4.57325 19.3864 4.57324 18.6106C4.57365 17.8351 5.20201 17.2063 5.97754 17.2063H15.2295L2 3.9768L2.23047 4.20629Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
